import {
  CommonBaseLayoutSchema,
  CommonButtonConfigComponent,
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
  RichTextAdvancedSchema,
  VoteType,
  WidgetType,
  type IWidgetComponentProps,
} from '@framework/engine';
import { FormItem, SelectInput } from '@framework/form';
import { yup } from '@framework/validation';
import { ConfigCardPanelContainer } from '../candidate/ConfigCardPanelContainer';
import { type IVoteWidget } from './IVoteWidget';

export const VoteWidgetConfigSchema: yup.ObjectSchema<IVoteWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Vote).required(),
    voteType: yup
      .mixed<VoteType>()
      .oneOf(Object.values(VoteType))
      .label('Tipo di votazione')
      .required()
      .default(VoteType.CTS),
    label: RichTextAdvancedSchema.optional().label('Etichetta'),
    panelTitle: RichTextAdvancedSchema.optional().label('Titolo del Pannello'),
    showPanel: yup.boolean().required().default(false),
    layout: CommonBaseLayoutSchema,
  });

export interface IVoteWidgetConfigComponentProps
  extends IWidgetComponentProps<IVoteWidget> {}

/**
 * Componente di configurazione per il widget di voto.
 */
export function VoteWidgetConfigComponent(
  props: IVoteWidgetConfigComponentProps,
) {
  return (
    <div>
      <FormItem
        name="voteType"
        label="Tipo di votazione"
        help="CTS: selezione di un candidato per comitato. CS: scelta di una lista elettorale (da usare insieme al widget Scelta Lista Elettorale)."
      >
        <SelectInput
          name="voteType"
          options={[
            { value: VoteType.CTS, label: 'CTS' },
            { value: VoteType.CS, label: 'CS' },
          ]}
        />
      </FormItem>
      <CommonConfigComponent
        {...props}
        hideConfigPlaceholder={true}
        hideConfigDefaultValue={true}
      />
      <CommonButtonConfigComponent />

      {/* Card di configurazione pannello (bordo) con titolo */}
      <ConfigCardPanelContainer />
    </div>
  );
}
